import {
  fetchAndActivate,
  getAll,
  getBoolean,
  getString,
} from "firebase/remote-config";
import { remoteConfig } from "../firebaseAnalytics";
import { setRemoteConfigValues } from "../store/questions/actions";

export const APPSTORE_LINK = "appstore_link";
export const ONBOARDING_WELCOME_ENABLED = "onboarding_welcome_enabled";
export const ONBOARDING_SLEEP_STORY_ENABLED = "onboarding_sleep_story_enabled";
export const ONBOARDING_SLEEP_SOUNDS_ENABLED = "onboarding_sleepsounds_enabled";
export const ONBOARDING_PAYWALL_ID = "onboarding_paywall_id";
export const ONBOARDING_ASK_EMAIL_CONFIG = "onboarding_ask_email_config";
export const EXPERIMENTS = "experiments";
export const PAID_TRIAL_ENABLED = "paid_trial_enabled";
export const PAYPAL_ENABLED = "paypal_enabled";
export const PAYWALL_OFFER_ID = "paywall_offer_id";

export const remoteFunction = (dispatch) => {
  let welcome;
  let paywallId;
  let createContent;
  let experiments;
  let storeLink;
  let sleepStoryEnabled;
  let sleepSoundsEnabled;
  let paidTrialEnabled;
  let paypalEnabled;
  let paywallOfferId;
  fetchAndActivate(remoteConfig)
    .then(() => {
      return getAll(remoteConfig);
    })
    .then(() => {
      storeLink = getString(remoteConfig, APPSTORE_LINK);
      welcome = getBoolean(remoteConfig, ONBOARDING_WELCOME_ENABLED);
      sleepStoryEnabled = getBoolean(
        remoteConfig,
        ONBOARDING_SLEEP_STORY_ENABLED
      );
      sleepSoundsEnabled = getBoolean(
        remoteConfig,
        ONBOARDING_SLEEP_SOUNDS_ENABLED
      );
      paywallId = getString(remoteConfig, ONBOARDING_PAYWALL_ID);
      createContent = getString(remoteConfig, ONBOARDING_ASK_EMAIL_CONFIG);
      paidTrialEnabled = getBoolean(remoteConfig, PAID_TRIAL_ENABLED);
      paypalEnabled = getBoolean(remoteConfig, PAYPAL_ENABLED);
      paywallOfferId = getString(remoteConfig, PAYWALL_OFFER_ID);
      experiments = getString(remoteConfig, EXPERIMENTS)
        .split(", ")
        .map((experimentName) => {
          return {
            [experimentName]: getString(remoteConfig, experimentName),
          };
        });
    })
    .catch((e) => {
      welcome = remoteConfig.defaultConfig[ONBOARDING_WELCOME_ENABLED];
      paywallId = remoteConfig.defaultConfig[ONBOARDING_PAYWALL_ID];
      createContent = remoteConfig.defaultConfig[ONBOARDING_ASK_EMAIL_CONFIG];
      //
      experiments = remoteConfig.defaultConfig[EXPERIMENTS];
      storeLink = remoteConfig.defaultConfig[APPSTORE_LINK];
      sleepStoryEnabled =
        remoteConfig.defaultConfig[ONBOARDING_SLEEP_STORY_ENABLED];
      sleepSoundsEnabled =
        remoteConfig.defaultConfig[ONBOARDING_SLEEP_SOUNDS_ENABLED];
      paidTrialEnabled = remoteConfig.defaultConfig[PAID_TRIAL_ENABLED];
      paypalEnabled = remoteConfig.defaultConfig[PAYPAL_ENABLED];
      paywallOfferId = remoteConfig.defaultConfig[PAYWALL_OFFER_ID];
    })
    .finally(() => {
      let remoteObject = {
        welcome,
        paywallId: Number(paywallId),
        createContent: JSON.parse(createContent),
        experiments: experiments,
        storeLink,
        sleepStoryEnabled,
        sleepSoundsEnabled,
        paidTrialEnabled,
        paypalEnabled,
        paywallOfferId,
      };
      dispatch(setRemoteConfigValues(remoteObject));
    });
};
